// extracted by mini-css-extract-plugin
export default {"productForm":"productForm__7Cswc","item":"item__fd4d3","title":"title__4MmC0","desc":"desc__m2Ax2","link-wrap":"link-wrap__rCXVd","link":"link__ybquA"};